import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import AdminLogin from "./screens/admin/auth/AdminLogin";
import Home from "./screens/customer/Home/home";
import CustomerDashboard from "./screens/customer/dashboard/CustomerDashboard";
import "./App.css";
import AdminDashboard from "./screens/admin/dashboard/AdminDashboard";
import AdminSubAdmins from "./screens/admin/Sub-Admins/AdminSubAdmins";
// import AdminSuppliers from "./screens/admin/adminSuppliers/AdminSuppliers";
// import AdminCustomers from "./screens/admin/adminCustomers/AdminCustomers";
import AdminDistributors from "./screens/admin/adminDistributors/AdminDistributors";
import AdminCityAreas from "./screens/admin/adminCityAreas/AdminCityAreas";
import AdminSubscriptions from "./screens/admin/adminSubscriptions/AdminSubscriptions";
// import AdminReports from "./screens/admin/adminReports/AdminReports";
import AdminDisputes from "./screens/admin/adminDisputes/AdminDisputes";
import AdminSettings from "./screens/admin/adminSettings/AdminSettings";

import DistributorLogin from "./screens/distributor/authDistributor/DistributorLogin";
import DistributorDashboard from "./screens/distributor/distributorDashboard/DistributorDashboard";
import DistributorMyCustomers from "./screens/distributor/distributorMyCustomers/DistributorMyCustomers";
// import DistributorMySuppliers from "./screens/distributor/distributorMySuppliers/DistributorMySuppliers";
import DistributorMilkDiary from "./screens/distributor/distributorMilkDiary/DistributorMilkDiary";
import DistributorDisputeSupport from "./screens/distributor/distributorDisputeSupport/DistributorDisputeSupport";
import DistributorPayments from "./screens/distributor/distributorPayments/DistributorPayments";
import DistributorSubscription from "./screens/distributor/distributorSubscription/DistributorSubscription";
import DistributorAreaManagement from "./screens/distributor/distributorAreaManagement/DistributorAreaManagement";
import DistributorNotifications from "./screens/distributor/distributorNotifications/DistributorNotifications";
// import DistributorAnalytics from "./screens/distributor/distributorAnalytics/DistributorAnalytics";
import DistributorSettings from "./screens/distributor/distributorSettings/DistributorSettings";
import DistributorSignUp from "./screens/distributor/distributorSignUp/DistributorSignUp";

// import SupplierLogin from "./screens/supplier/SupplierAuth/SupplierLogin";
// import SupplierSignUp from "./screens/supplier/SupplierAuth/SupplierSignUp";
// import SupplierDashboard from "./screens/supplier/supplierDashboard/SupplierDashboard";
// import SupplierMyDistributors from "./screens/supplier/supplierMyDistributors/SupplierMyDistributors";
// import SupplierSupplyDiary from "./screens/supplier/supplierSupplyDiary/SupplierSupplyDiary";
// import SupplierPayments from "./screens/supplier/supplierPayments/SupplierPayments";
// import SupplierRevenue from "./screens/supplier/supplierRevenue/SupplierRevenue";
// import SupplierDisputes from "./screens/supplier/supplierDisputes/SupplierDisputes";
// import SupplierNotifications from "./screens/supplier/supplierNotifications/SupplierNotifications";
// import SupplierSettings from "./screens/supplier/supplierSettings/SupplierSettings";
// import SupplierKYC from "./screens/supplier/supplierKYC/SupplierKYC";

import About from "./screens/customer/about/About";
import Contact from "./screens/customer/contact/Contact";
import FakeApi from "./screens/customer/fakeApi/FakeApi";
import Notfound from "./screens/customer/notfound/Notfound";
import Distributors from "./screens/customer/distributors/Distributors";
import Pricing from "./screens/customer/pricing/Pricing";
// import MyLayout from "./layouts/customer/MyLayout";
import Trainings from "./trainings/Trainings";
import Login from "./screens/customer/Login/login";
import RoleSelection from "./screens/customer/roleSelection/RoleSelection";
import CustomerPanelDashboard from "./screens/customer/roleSelection/customerDashboard/CustomerPanelDashboard";
import CustomerMyDiary from "./screens/customer/roleSelection/customerMyDiary/CustomerMyDiary";
import CustomerSettings from "./screens/customer/roleSelection/customerSettings/CustomerSettings";
import PaymentHistory from "./screens/customer/roleSelection/paymentHistory/CustomerBilling";
import CustomerPaymentHistory from "./screens/customer/roleSelection/paymentHistory/CustomerBilling";
// import CustomerSubscription from "./screens/customer/roleSelection/customerSubscription/CustomerSubscription";
import CustomerSupport from "./screens/customer/roleSelection/customerSupport/CustomerSupport";
import CustomerRegister from "./screens/customer/roleSelection/customerRegister/CustomerRegister";
import CustomerLogin from "./screens/customer/roleSelection/customerLogin/CustomerLogin";
import CustomerNotifications from "./screens/customer/roleSelection/customerNotifications/CustomerNotifications";
import AdminNotifications from "./screens/admin/adminNotifications/AdminNotifications";
import AdminBlogManagement from "./screens/admin/adminBlogManagement/AdminBlogManagement";
import PublicBlog from "./screens/customer/blogs/PublicBlog";
import PublicBlogDetail from "./screens/customer/blogs/Publicblogdetail";

function App() {
  return (
    // <BrowserRouter>
      <Routes>

        {/* ✅ Customer Layout Routes */}
        {/* <Route path="/" element={<MyLayout />}> */}
          {/* <Route index element={<Home />} />         "/" */}
          <Route path="/" element={<Home />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/distributors" element={<Distributors />} />
          <Route path="/about" element={<About />} />
          <Route path="/blogs" element={<PublicBlog />} />
          <Route path="/blog/:slug" element={<PublicBlogDetail />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/fakeApi" element={<FakeApi />} />
          <Route path="/login" element={<RoleSelection />} />

          <Route path="/customer/register" element={<CustomerRegister />} />
          <Route path="/customer/login" element={<CustomerLogin />} />
          <Route path="/customer/dashboard" element={<CustomerPanelDashboard />} />
          <Route path="/customer/dairy" element={<CustomerMyDiary />} />
          <Route path="/customer/settings" element={<CustomerSettings />} />
          <Route path="/customer/billing" element={<CustomerPaymentHistory />} />
          {/* <Route path="/customer/subscription" element={<CustomerSubscription />} /> */}
          <Route path="/customer/support" element={<CustomerSupport />} />
          <Route path="/customer/notifications" element={<CustomerNotifications />} />


        {/* </Route> */}

        {/* Standalone Routes (no MyLayout) */}
        <Route path="/login" element={<Login />} />
        <Route path="/trainings" element={<Trainings />} />
        <Route path="/customer-dashboard" element={<CustomerDashboard />} />

        {/* Admin Routes */}
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        {/* <Route path="/admin/suppliers" element={<AdminSuppliers />} /> */}
        <Route path="/admin/subadmins" element={<AdminSubAdmins />} />
        <Route path="/admin/distributors" element={<AdminDistributors />} />
        { /*<Route path="/admin/customers" element={<AdminCustomers />} /> */}
        <Route path="/admin/city-areas" element={<AdminCityAreas />} />
        <Route path="/admin/subscriptions" element={<AdminSubscriptions />} />
        <Route path="/admin/notifications" element={<AdminNotifications />} />
        <Route path="/admin/blogs" element={<AdminBlogManagement />} />
        
        {/* <Route path="/admin/reports" element={<AdminReports />} /> */}
        <Route path="/admin/disputes" element={<AdminDisputes />} />
        <Route path="/admin/settings" element={<AdminSettings />} />

        {/* Distributor Routes */}
        <Route path="/distributor-login" element={<DistributorLogin />} />
        <Route path="/distributor/dashboard" element={<DistributorDashboard />} />
        <Route path="/distributor/customers" element={<DistributorMyCustomers />} />
        {/* <Route path="/distributor/suppliers" element={<DistributorMySuppliers />} /> */}
        <Route path="/distributor/milk-diary" element={<DistributorMilkDiary />} />
        <Route path="/distributor/disputes" element={<DistributorDisputeSupport />} />
        <Route path="/distributor/payments" element={<DistributorPayments />} />
        <Route path="/distributor/subscription" element={<DistributorSubscription />} />
        <Route path="/distributor/area-management" element={<DistributorAreaManagement />} />
        <Route path="/distributor/notifications" element={<DistributorNotifications />} />
        {/* <Route path="/distributor/analytics" element={<DistributorAnalytics />} /> */}
        <Route path="/distributor/settings" element={<DistributorSettings />} />
        <Route path="/distributor-signup" element={<DistributorSignUp />} />

        {/* Supplier Routes */}
        {/* <Route path="/supplier/login" element={<SupplierLogin />} />
        <Route path="/supplier/signup" element={<SupplierSignUp />} />
        <Route path="/supplier/dashboard" element={<SupplierDashboard />} />
        <Route path="/supplier/distributors" element={<SupplierMyDistributors />} />
        <Route path="/supplier/supply-diary" element={<SupplierSupplyDiary />} />
        <Route path="/supplier/payments" element={<SupplierPayments />} />
        <Route path="/supplier/analytics" element={<SupplierRevenue />} />
        <Route path="/supplier/disputes" element={<SupplierDisputes />} />
        <Route path="/supplier/kyc" element={<SupplierKYC />} />
        <Route path="/supplier/notifications" element={<SupplierNotifications />} />
        <Route path="/supplier/settings" element={<SupplierSettings />} /> */}

        {/* 404 */}
        <Route path="*" element={<Notfound />} />

      </Routes>
    //  </BrowserRouter>
  );
}

export default App;